module.exports = __webpack_public_path__ + "static/devices-5f269e9becf9964d516be9c39e6d9255.jpg";